import { Component } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css'],

})
export class BaseComponent {

  constructor(private route: Router) {
    // if (!localStorage.getItem(environment.localStorageKey)) {
    //   this.route.navigate(["/"]);
    // }

  }



}
